import React, { useEffect } from 'react';
import { favoriteBetsStore } from '../../store/favoriteBetsStore';
import { FavoriteBetsHeader } from './favoriteBetsHeader';
import { FavoriteBetsRows } from './favoriteBetsRows';
import { FavoriteBetFooter } from './favoriteBetFooter';
import { observer } from 'mobx-react-lite';
import { doChipStore } from '../../store/doChipStore';
import { getKeyByValue } from '../../helpers/getKeyByValue';
import { marketType } from '../../enums/marketType';
import { useRouletteDoBetValidation } from '../../hooks/useRouletteDoBetValidation';
import { betResponseCodeByName } from '../../enums/betResponseCode';
import { gameConfigStore, notificationStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../../store/gameStore';

export const FavoriteBets = observer(({ setIsShowBetActionModal }) => {
  const { gameTypeId } = gameConfigStore;
  const { favoriteBets } = favoriteBetsStore;
  const { resetForFavoriteBets } = doChipStore;
  const { handleDoBetInCombination, handleDoBetWithValid } = useRouletteDoBetValidation();
  const { balance } = userInfoStore;
  const { isBetsClosed } = gameStore;

  useEffect(async () => {
    favoriteBetsStore.getFavoriteBets(gameTypeId);
  }, []);

  const handleDoFavoriteBet = (favoriteBets, totalBet, isEdit) => {
    if (isBetsClosed || isEdit) {
      return;
    }

    const validateResults = favoriteBets.reduce((acc, cur) => {
      const betType = getKeyByValue(marketType, cur.bet.type);
      if (cur.includedBets) {
        const betCombination = cur.includedBets.map((bet) => getKeyByValue(marketType, bet.type));
        const result = handleDoBetInCombination(betCombination, cur.bet.amount, betType, true);
        if (result) {
          acc.push(...result?.map((item) => item[item.type]));
        }
      } else {
        const nextChipModel = {
          [betType]: cur.bet.amount,
          chipType: betType,
        };
        acc.push(handleDoBetWithValid(nextChipModel, true));
      }
      return acc;
    }, []);

    if (validateResults.some((item) => !item)) {
      if (totalBet > balance) {
        notificationStore.setNotificationType(betResponseCodeByName.NotEnoughBalance);
        setTimeout(() => {
          notificationStore.setNotificationType(null);
        }, 1000);
      } else {
        notificationStore.setNotificationType(betResponseCodeByName.InValidMaxBet);
        setTimeout(() => {
          notificationStore.setNotificationType(null);
        }, 1000);
      }
      return;
    }

    favoriteBets.forEach((item) => {
      const betType = getKeyByValue(marketType, item.bet.type);
      if (item.includedBets) {
        const betCombination = item.includedBets.map((bet) => getKeyByValue(marketType, bet.type));
        handleDoBetInCombination(betCombination, item.bet.amount, betType);
      } else {
        const nextChipModel = {
          [betType]: item.bet.amount,
          chipType: betType,
        };
        handleDoBetWithValid(nextChipModel);
      }
    });
    resetForFavoriteBets(favoriteBets.length);
  };

  return (
    <div className='roulette-action-popover'>
      <div className='r-a-p-inner'>
        <FavoriteBetsHeader setIsShowBetActionModal={setIsShowBetActionModal} />
        <div className='r-a-p-content'>
          <div className='r-a-p-content-inner scrollable'>
            <div className='r-a-p-info'>
              {favoriteBets.map(({ id, name, favouriteBets }) => (
                <FavoriteBetsRows
                  handleDoFavoriteBet={handleDoFavoriteBet}
                  key={id}
                  id={id}
                  name={name}
                  favouriteBets={favouriteBets}
                />
              ))}
              )
            </div>
          </div>
        </div>
        <FavoriteBetFooter />
      </div>
    </div>
  );
});
